import { usePostHogCapture } from '@app/core/integrations/posthog/usePostHogCapture';
import CachedIcon from '@mui/icons-material/Cached';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { Alert, Box, Button, Snackbar } from '@mui/material';
import { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useForceUpdateOldVersion } from './useForceUpdateOldVersion';
import { useVersionCheck } from './useVersionCheck';

export const VersionChecker = () => {
  const { shouldShowFullAlert, dismiss, markAlertShown, reload } = useVersionCheck();
  const capture = usePostHogCapture();
  const hasCapturedShownRef = useRef(false);

  useForceUpdateOldVersion();

  useEffect(() => {
    if (shouldShowFullAlert && !hasCapturedShownRef.current) {
      hasCapturedShownRef.current = true;
      capture('new_version_available_shown', {
        type: 'alert',
      });
    }
  }, [shouldShowFullAlert, capture]);

  const handleReload = () => {
    reload('alert');
  };

  const handleDismiss = () => {
    markAlertShown();
    capture('new_version_dismissed');
    dismiss();
  };

  return (
    <Snackbar
      open={shouldShowFullAlert}
      onClose={handleDismiss}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ zIndex: 99999 }}
    >
      <Alert variant="filled" severity="success" icon={<NewReleasesIcon />} onClose={handleDismiss}>
        <Box>
          <Box>
            <FormattedMessage
              id="ui.versionChecker.newVersionAvailable"
              defaultMessage="Una nueva versión del app está disponible"
            />
          </Box>
          <Box mt={2}>
            <Button
              size={'small'}
              onClick={handleReload}
              startIcon={<CachedIcon />}
              color="inherit"
              variant="outlined"
            >
              <FormattedMessage id="common.actions.reload" defaultMessage="Recargar" />
            </Button>
          </Box>
        </Box>
      </Alert>
    </Snackbar>
  );
};
